import axios from 'axios'
import qs from 'qs'
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from '../../urlLink'
const root = Urls.crmApiUrl //域名
//首页数据请求
const url = {
  getCompanyClient:root+"/Client/getCompanyClient",
  getSchoolByActivity:root+"/Client/getSchoolByActivityApi",
  allotSchool:root+"/Client/allotSchoolAction",
  // gettoMyClient:root+"/Client/toMyClientApi",
  // addClient:root+"/Client/addClientAction",
}
const storeClientManage=  {
  //客户管理->客户列表
  getCompanyClient(params){
    return axios.get(url.getCompanyClient,{ params })
  },
  //客户管理->客户列表---导出
  getCompanyClient1(){
    return url.getCompanyClient
  },
  // 客户管理->获取该活动参与的学校
  getSchoolByActivity(params){
    return axios.get(url.getSchoolByActivity,{ params })
  },
  //客户管理->分配到学校
  allotSchool(params){
    return axios.post(url.allotSchool,qs.stringify(params))
  },
}

export default storeClientManage;